import { threadId } from 'worker_threads';
import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { ApiService } from '../../../services/api.service';
import { UserWatchingHistoryService } from '../../../services/user-watching-history.service';
import { Input } from '../../../../../lib/web/components/input';
import { MediaPlayerService, MediaType } from '../../../services/media-player.service';
import { Str } from '../../../../../lib/web/core/str';
import { SessionService } from '../../../services/session.service';
import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { ItemSelectorDropdownComponent } from '../../atoms/item-selector-dropdown/item-selector-dropdown.component';
import { SessionStorageService } from '../../../../../lib/web/services/session-storage.service';

@Component({
    selector: '.o-list-content'
})
export class ListContentComponent extends ComponentBase<HTMLElement> {

    @Input('collection-id')
    private _collectionId: number = null;
    @Input('image')
    private _image: string = null;

    @ChildRef('.o-list-content__select-list')
    private _selectListElement: HTMLButtonElement = null;
    @ChildRef('.o-list-content__list-selector .a-item-selector-dropdown')
    private _listSelector: ItemSelectorDropdownComponent = null;

    public constructor(node: HTMLElement,
        private _sessionStorageService: SessionStorageService,  
        private _apiService: ApiService,
        private _sessionService: SessionService,
        private _mediaPlayerService: MediaPlayerService,
        private _userWatchingHistoryService: UserWatchingHistoryService) {

        super(node);

        this.addWindowEventListener('user-watching-history-changed', () => this.loadUserProgress());
    }

    public onInit(): void {
    }

    @ClickListener('.o-list-content__play')
    public onPlayClick(e: MouseEvent): void {
        e.preventDefault();
        e.stopPropagation();
        this.playChapter((e.target as HTMLElement).closest('.o-list-content__item') as HTMLAnchorElement);
    }

    @ClickListener('.o-list-content__share')
    public onShareClick(e: MouseEvent): void {
        e.preventDefault();
        e.stopPropagation();
    }

    @ClickListener('.o-list-content__select-list')
    public onSelectList(e: MouseEvent): void {
        this.toggleLists(e);
    }

    private async toggleLists(e: MouseEvent): Promise<void> {
        const arrowElement: HTMLElement = this._selectListElement.querySelector('.u-arrow');
        arrowElement.classList.remove('u-arrow--down');
        arrowElement.classList.add('u-arrow--up');
        const selected: number = await this._listSelector.toggle({ selected: null, element: this._selectListElement, mode: 'centered' }, e);        
        arrowElement.classList.remove('u-arrow--up');
        arrowElement.classList.add('u-arrow--down');
        if (selected) {
            this.setSelectedList(selected);
        }       
    }
    
    private setSelectedList(selected: number): void {
        const lists: HTMLDivElement[] = Array.from(this._node.querySelectorAll('.o-list-content__list')) as HTMLDivElement[];
        lists.forEach(list => {
            list.classList.remove('o-list-content__list--selected');
        });
        const selectedList: HTMLDivElement = this._node.querySelector(`.o-list-content__list[data-id="${selected}"]`) as HTMLDivElement;
        selectedList.classList.add('o-list-content__list--selected');
    }

    private async playChapter(item: HTMLAnchorElement): Promise<void> {
        let chapterUrl: string = item.getAttribute('href');
        const freePlay: boolean = item.dataset.capsuleFreePlay === 'true';
        if (this._sessionService.isSigned || freePlay) {
            let capsuleId: number = parseInt(item.dataset.capsuleId);
            if (this._userWatchingHistoryService.isWatching(this._collectionId, 'collection')) {
                capsuleId = this._userWatchingHistoryService.getItem(this._collectionId, 'collection').capsuleId;
                const { isArchived } = this._userWatchingHistoryService.getItem(capsuleId, 'capsule');
                chapterUrl = await this._apiService.get(`/api/v1/collection/continue-url/${this._collectionId}/${capsuleId}/${isArchived}`);            
            }
            this.loadPlayer(false, 'capsule', {
                capsuleId,
                url: chapterUrl,
                playerType: item.dataset.playerType
            });
        } 
        else {
            this._sessionStorageService.set('redirect-after-sign-in', chapterUrl);
            this.redirect('/u/sign-in');
        }
    }

    private async loadPlayer(pushState: boolean = true, type: MediaType = 'capsule', chapter?: any): Promise<void> {                
        this._mediaPlayerService.loadMedia(chapter.playerType, {
            capsuleId: type == 'capsule' ? chapter.capsuleId: null,
            collectionId: this._collectionId,
            type,
            image: this._image,
            owner: type == 'capsule' 
                ? {  pathname: chapter.url,
                    target: chapter.url
                }
                : {
                    pathname: location.pathname,
                    target: Str.getRelativeUrl(location.href)
                }        
            });        
    }

    private loadUserProgress(): void {
        const items: HTMLDivElement[] = Array.from(this._node.querySelectorAll('.o-list-content__item'));
        items?.forEach(item => {
            const id: number = parseInt(item.dataset.capsuleId);
            const watchingHistory: any = this._userWatchingHistoryService.getItem(id, 'capsule');
            this.setProgress(item, watchingHistory);
        });
    }

    private setProgress(itemElement: HTMLDivElement, data: { current: number, duration: number }): void {        
        if (itemElement) {
            const { current, duration } = data || {};
            if (current) {
                const progressValueElement: HTMLDivElement = itemElement.querySelector('.o-list-content__item-progress-value');
                if (progressValueElement) {
                    itemElement.classList.add('o-list-content__item--with-progress');
                    progressValueElement.style.width = `${((current || 0) / (duration || 1)) * 100}%`;
                }
            }
            else {
                itemElement.classList.remove('o-list-content__item--with-progress');
            }
        }
    }
}